import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LinkInternoVoltarContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getLinkInternoVoltar(id: string): Observable<any> {
    return this.getLinkInternoVoltarContents(id).pipe(
      map(res => this.buildResponseLinkInternoVoltarObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryLinkInternoVoltarContents[0].flatData;
  }

  private getLinkInternoVoltarContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryLinkInternoVoltarContents(filter: "id eq '${id}'") {
          flatData {
            nome
            titulo
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseLinkInternoVoltarObject(data: any) {
    return {
      title: data.titulo,
      page: data.pagina && data.pagina.length > 0
          ? '/paginas/' + data.pagina[0].data.slug.iv
          : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }

}

